import type { TourConfig } from './types';

export const organizationSettingsTour: TourConfig = {
  id: 'organization-settings-page',
  name: 'Organization Settings Tour',
  description: 'Learn about organization settings options',
  requiredPath: '/dashboard/settings/organization',
  steps: [
    {
      element: '[data-tour="org-basic-info"]',
      popover: {
        title: 'Basic Information',
        description:
          'Set your organization name and upload a logo that appears on client documents.',
        side: 'bottom',
        align: 'start',
      },
    },
    {
      element: '[data-tour="org-contact-info"]',
      popover: {
        title: 'Contact Information',
        description:
          'Add your phone, email, and website so clients can reach you.',
        side: 'bottom',
        align: 'start',
      },
    },
    {
      element: '[data-tour="org-address"]',
      popover: {
        title: 'Address',
        description:
          'Enter your business address that appears on invoices and documents.',
        side: 'bottom',
        align: 'start',
      },
    },
    {
      element: '[data-tour="org-privacy-terms"]',
      popover: {
        title: 'Privacy & Terms',
        description:
          'Set the Privacy Policy and Terms & Conditions URLs shown in the client mobile app.',
        side: 'bottom',
        align: 'start',
      },
    },
    {
      element: '[data-tour="org-client-app"]',
      popover: {
        title: 'Client App Settings',
        description:
          'Configure Google and Apple sign-in options and control dietitian visibility in the client app.',
        side: 'bottom',
        align: 'start',
      },
    },
    {
      element: '[data-tour="org-invoice-settings"]',
      popover: {
        title: 'Invoice Settings',
        description:
          'Set your invoice number prefix and default footer notes for all new invoices.',
        side: 'bottom',
        align: 'start',
      },
    },
    {
      element: '[data-tour="org-pdf-template"]',
      popover: {
        title: 'PDF Export Template',
        description:
          'Choose the visual style for exported diet plan PDFs sent to clients.',
        side: 'top',
        align: 'start',
      },
    },
  ],
};
